import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { SERVER_URL } from './config';
import './InvitationResponse.css';

const InvitationResponse = () => {
  const { uuid } = useParams();
  const [invited, setInvited] = useState({});
  const [arriving, setArriving] = useState(0);
  const [command, setCommand] = useState('');
  const [loading, setLoading] = useState(true);
  const [guestCount, setGuestCount] = useState(''); // For number of attendees
  const [isEditing, setIsEditing] = useState(false); // Track if editing

  useEffect(() => {
    axios.get(`${SERVER_URL}invitation/confirm/${uuid}/`)
      .then(response => {
        setInvited(response.data);
        setArriving(response.data.arriving);
  
        // Check if arriving is null and set editing mode
        if (response.data.arriving === null) {
          setIsEditing(true);
        }
  
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching invitation:', error);
        alert('Error fetching invitation. Please try again later.');
        setLoading(false);
      });
  }, [uuid]);
  
  

  const handleEditClick = () => {
    setIsEditing(true); // Enable editing mode
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      arriving: arriving === "1" && guestCount ? guestCount : arriving,
      command, // Additional notes
    };

    axios.post(`${SERVER_URL}invitation/confirm/${uuid}/`, data)
      .then(() => {
        alert('תודה רבה על תשובתכם!');
        setIsEditing(false); // Exit editing mode
      })
      .catch(error => {
        console.error('Error saving response:', error);
        alert('Error saving response. Please try again.');
      });
  };

  useEffect(() => {
    if (invited.arriving != null) {
      console.log("Updated arriving:", invited.arriving);
    }
  }, [invited]);

  if (loading) return <p>טוען נתונים...</p>;

  return (
    <div className="invitation-container">
      <h1 translate="no">💍 הנכם מוזמנים לחתונה של {invited.groom} ו-{invited.bride} 💍</h1>
      <p className="invitation-details" translate="no">
        שלום {invited.name}, <br />
        אנו שמחים להזמינכם לחגוג עמנו את יום חתונתם של {invited.groom} ו-{invited.bride} באולם {invited.hall}.<br />
        האירוע יתקיים ב {invited.date} בשעה {invited.time}.
      </p>
      {invited.command && (
        <p className="something-to-say">
          <strong> {invited.command}</strong>
        </p>
      )}

      {!isEditing ? (
        <div className="response-summary">
{ invited.arriving > 0 ? ( // Handles null and undefined
            <h2 translate="no">תודה שאישרתם הגעה מחכים לראותכם</h2>
          ) : (
            <h2 translate="no">תודה שעדכנתם</h2>
          )}
          <button onClick={handleEditClick} translate="no">לשינוי לחץ כאן</button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="response-form">
          <h2>אשרו את הגעתכם</h2>
          <label>
            <span>האם תגיעו?</span>
            <div className="radio-group">
              <div>
                <input
                  type="radio"
                  id="attending_yes"
                  name="attendance"
                  value="1"
                  checked={arriving === "1"}
                  onChange={(e) => setArriving(e.target.value)}
                />
                <label htmlFor="attending_yes">ברור שאגיע!</label>
              </div>
              <div>
                <input
                  type="radio"
                  id="attending_no"
                  name="attendance"
                  value="0"
                  checked={arriving === "0"}
                  onChange={(e) => setArriving(e.target.value)}
                />
                <label htmlFor="attending_no">לצערי לא מתאפשר לי</label>
              </div>
            </div>
          </label>

          {arriving === "1" && (
            <label>
              <span>כמה תגיעו?</span>
              <input
  type="number"
  inputMode="numeric"
  pattern="\d*"
  min="1"
  value={guestCount}
  onChange={(e) => setGuestCount(e.target.value)}
  autoFocus
/>
            </label>
          )}

          <label>
  <span>הערות נוספות? (מוגבל ל30 תווים)</span>
  <textarea
    placeholder="כתבו כאן הערות נוספות..."
    value={command}
    onChange={(e) => {
      if (e.target.value.length <= 30) {
        setCommand(e.target.value);
      }
    }}
    maxLength={30} // Limit input to 30 characters
  />
</label>

          <button type="submit">שלחו תשובה</button>
        </form>
      )}
    </div>
  );
};

export default InvitationResponse;
